import React from 'react';
import styled from 'styled-components/macro';
import {
  colourGreen05,
  colourGreen07,
  colourGreen09,
  colourNeutral05,
  colourNeutral07,
  colourNeutral09,
  colourRed07,
  colourRed08,
  colourRed09,
  colourYellow04,
  colourYellow07,
  colourYellow09,
} from '../styling/colours';
import { fontSize01, fontWeightBold } from '../styling/fonts';
import { spacing01, spacing03 } from '../styling/spacing';

export const Badge = styled.span<{ $backgroundColor: string; $textColour: string; $borderColour: string }>`
  background-color: ${props => props.$backgroundColor};
  border: solid 1px ${props => props.$borderColour};
  color: ${props => props.$textColour};
  font-weight: ${fontWeightBold};
  padding: ${spacing01} ${spacing03};
  border-radius: 100px;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  font-size: ${fontSize01};
`;

type Props = {
  children?: React.ReactNode;
};

export const NeutralBadge = (props: Props) => (
  <Badge $backgroundColor={colourNeutral09} $textColour={colourNeutral05} $borderColour={colourNeutral07}>
    {props.children}
  </Badge>
);

export const SuccessBadge = (props: Props) => (
  <Badge $backgroundColor={colourGreen09} $textColour={colourGreen05} $borderColour={colourGreen07}>
    {props.children}
  </Badge>
);

export const WarningBadge = (props: Props) => (
  <Badge $backgroundColor={colourYellow09} $textColour={colourYellow04} $borderColour={colourYellow07}>
    {props.children}
  </Badge>
);

export const ErrorBadge = (props: Props) => (
  <Badge $backgroundColor={colourRed09} $textColour={colourRed07} $borderColour={colourRed08}>
    {props.children}
  </Badge>
);
